import { EventStageAttributes } from '@/types'
import { UpdateEventStageMutation } from './__generated__/update_mutation'
import { Mutation as UpdateMutation } from './update_mutation'
import { useForm } from '@/helpers/useForm'
import { EditEventStageQuery } from './__generated__/edit_query'
import { Query as EditQuery } from './edit_query'
import { Inline as Loading } from '@/components/loading'
import { useEffect, useState } from 'react'
import { Query as TableQuery } from './table_query'
import { Button } from '@/components/base/button'
import { DeleteDialog } from '@/components/delete_dialog'
import { Mutation as DeleteMutation } from './delete_mutation'
import { Inline as Error } from '@/components/error'

type Event = EditEventStageQuery['events']['nodes'][0]

interface Props {
  eventId: string
  id: string
  onSuccess: () => void
}

export const Form = ({ eventId, id, onSuccess }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    queryError,
    queryLoading,
    mutationLoading
  } = useForm<UpdateEventStageMutation, EventStageAttributes, EditEventStageQuery, Event>({
    queryVariables: { eventId, eventStageId: id },
    id,
    initializer: event => {
      const eventStage = event.eventStages.nodes[0]
      return {
        eventId,
        name: eventStage.name,
        notes: eventStage.notes,
      }
    },
    query: EditQuery,
    queryKey: 'events',
    mutation: UpdateMutation,
    resultKey: 'updateEventStage',
    refetchQueries: [TableQuery]
  })
  const [showDelete, setShowDelete] = useState(false)

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  const onDelete = () => {
    setShowDelete(false)
    onSuccess()
  }

  if (queryLoading) return <Loading />

  return (
    <>
      { queryError && <Error message={queryError} /> }
      <div className="flex flex-col gap-6">
        { formBuilder.buildQueryError() }
        { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
        { formBuilder.buildField({ name: 'Notes', field: 'notes', type: 'textarea' }) }
        <div className="flex flex-row justify-between">
          <Button color="red" onClick={() => setShowDelete(true) }>Delete</Button>
          { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
        </div>
        <DeleteDialog
          id={id}
          mutation={DeleteMutation}
          open={showDelete}
          refetchQueries={[TableQuery]}
          setOpen={setShowDelete}
          onSuccess={onDelete}
        />
      </div>
    </>
  )
}
